<template>
  <span class="tabular-nums">{{ formatted }}</span>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  currencyCode: string;
  amount: number;
}>();

const formatter = computed(() => {
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: props.currencyCode,
  });
});

const formatted = computed(() => {
  return formatter.value.format(props.amount);
});
</script>
